import { useEffect, useState } from "react";
import Button from "../../../components/forms/Button";
import { useNavigate, useSearchParams } from "react-router-dom";
import NoColoringBook from "../../../components/sections/front/User/NoColoringBook";
import NewTabs from "../../../components/elements/NewTabs";
import ColoringBooks from "./ColoringBooks";
import UserInfo from "./UserInfo";
import useFetch from "../../../hooks/useFetch";
import { orderList } from "../../../services/orderService";
import dayjs from "dayjs";
import { fetchBatchImages } from "../../../services/mediaService";
import { profileDetails } from "../../../services/ProfileService";
import UploadCoverPhotoPage from "./UploadCoverPhotoPage";
import { useDispatch } from "react-redux";
import { setCoverImages, setImages } from "../../../redux/slice/sketchSlice";
import { useSelector } from "react-redux";

const UserLandingPage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [newOrder, setNewOrder] = useState(true);
  const [status] = useState("All");
  const [filters] = useState({
    limit: 10,
    page: 1,
  });

  const [sort] = useState("-date");
  const [keyword] = useState("");
  const [filterOn] = useState(false);
  const [dateRange] = useState({
    startDate: null,
    endDate: null,
  });

  const { activeBookId } = useSelector((state) => state.stepFlow);

  const { data: orders, isLoading: isLoadingOrders } = useFetch({
    dependencies: ["orders", filters, keyword, sort, dateRange, status],
    fetchFunction: async () => {
      const res = await orderList({
        ...filters,
        ...(filterOn && keyword && { keyword }),
        ...(filterOn && sort && { sortQuery: sort }),
        ...(filterOn &&
          dateRange?.startDate && {
          startDate: dayjs(dateRange.startDate).format("YYYY-MM-DD"),
        }),
        ...(filterOn &&
          dateRange?.endDate && {
          endDate: dayjs(dateRange.endDate).format("YYYY-MM-DD"),
        }),
        ...(filterOn && status && status !== "All" && { status }),
      });
      return res?.docs;
    },
  });

  // 🔹 Fetch profile + batch images using useFetch
  const { data: profileData } = useFetch({
    dependencies: ["profile"],
    fetchFunction: async () => await profileDetails(),
  });

  const lastBatchId = profileData?.data?.lastBatchDetails?.lastBatchId;

  // Check if user had placed order previously
  useEffect(() => {
    setNewOrder(orders?.metadata?.totalDocs === 0);
  }, [orders?.metadata?.totalDocs, dispatch, profileData?.data?.latestStepCode?.code]);

  useFetch({
    dependencies: ["batchImages", lastBatchId],
    enabled: !!lastBatchId,
    fetchFunction: async () => {
      if (!lastBatchId) return null;
      const result = await fetchBatchImages(lastBatchId);
      return result?.docs?.data || [];
    },
  });

  const onNavigateCreateBook = () => {
    dispatch(setCoverImages([]));
    dispatch(setImages([]));
    navigate("/create-book?stepCode=Create_New_Book");
  };

  const tabData = [
    {
      id: "coloring-books",
      label: "Coloring Books",
      icon: "fa-light fa-swatchbook",
      content: isLoadingOrders ? <div className="py-10 text-center text-gray-500">Loading books...</div> : newOrder ? <NoColoringBook /> : <ColoringBooks orders={orders?.data || []} />,
      tabActions: () => (
        <div className="w-full md:w-auto mb-4 md:mb-0">
          <Button buttonLabel="New Coloring Book" buttonIcon="fa-regular fa-plus" buttonIconPosition="left" buttonFunction={onNavigateCreateBook} buttonClasses="!rounded-lg !px-5 w-full md:w-auto" />
        </div>
      ),
    },
    {
      id: "my-info",
      label: "My Info",
      icon: "fa-light fa-square-info",
      content: <UserInfo />,
      tabActions: () => (
        <div className="w-full md:w-auto mb-4 md:mb-0">
          <Button buttonLabel="New Coloring Book" buttonIcon="fa-regular fa-plus" buttonIconPosition="left" buttonFunction={onNavigateCreateBook} buttonClasses="!rounded-lg !px-5 w-full md:w-auto" />
        </div>
      ),
    },
    {
      id: "billing",
      label: "Billing",
      icon: "fa-light fa-file-invoice",
      content: <></>,
      tabActions: () => (
        <div className="w-full md:w-auto mb-4 md:mb-0">
          <Button buttonLabel="New Coloring Book" buttonIcon="fa-regular fa-plus" buttonIconPosition="left" buttonFunction={onNavigateCreateBook} buttonClasses="!rounded-lg !px-5 w-full md:w-auto" />
        </div>
      ),
    },
  ];

  return (
    <section className="relative w-full">
      <div className="relative w-full px-0 sm:max-w-xl md:max-w-2xl lg:max-w-4xl xl:max-w-6xl 2xl:max-w-7xl mx-auto">{!!activeBookId ? <UploadCoverPhotoPage /> : <NewTabs data={tabData} />}</div>
    </section>
  );
};

export default UserLandingPage;
